import SeoLandingPage from "@/components/feature/SeoLandingPage";
import { seoPages } from "@/data/seoContent";

export default function OnlineDershane() {
  const data = seoPages.find((p) => p.slug === "online-egitim")!;
  return <SeoLandingPage data={data} />;
}